import { useMemo } from 'react';

import { useMerchantsListQuery } from '~platform/entities/merchant';

import { MultiSelectFilter } from '~shared/ui/multi-select-filter';

import { getMerchantOptions } from '../../lib/get-payments-filter-options';
import { PAYMENT_STATUS_OPTIONS } from '../../lib/payments-status-options';

type FieldProps = {
  onChange?: () => void;
};

export function StatusSelect({ onChange }: FieldProps) {
  return (
    <MultiSelectFilter
      name="statuses"
      label="Status"
      options={PAYMENT_STATUS_OPTIONS}
      onValueChange={onChange}
    />
  );
}

export function BusinessSelect({ onChange }: FieldProps) {
  const { data } = useMerchantsListQuery();
  const options = useMemo(() => getMerchantOptions(data ?? []), [data]);

  return (
    <MultiSelectFilter
      name="merchantIds"
      label="Businesses"
      options={options}
      onValueChange={onChange}
    />
  );
}
